import { FC, useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { useTranslation } from 'react-i18next';

import { WELCOME_STORAGE_KEY } from 'constants/common';
import WelcomeModal from 'components/modals/WelcomeModal';

const Footer: FC = () => {
  const { t: translate } = useTranslation();
  const [open, setOpen] = useState(!localStorage.getItem(WELCOME_STORAGE_KEY));

  return (
    <>
      <Stack direction="row" justifyContent="center" alignItems="center">
        <Button
          variant="text"
          color={'disabled' as any}
          sx={{
            p: 1,
            textTransform: 'capitalize',
          }}
          onClick={() => setOpen(true)}
        >
          {translate('Common.Help&Support')}
        </Button>

        <Divider
          orientation="vertical"
          flexItem
          color="common.grey"
          sx={{ bgcolor: 'common.grey' }}
        />

        <Typography
          color="common.grey"
          p={1}
          lineHeight={1.75}
          fontWeight={500}
        >
          {process.env.REACT_APP_VAULT_CONTEXT}
        </Typography>
        <Divider
          orientation="vertical"
          flexItem
          color="common.grey"
          sx={{ bgcolor: 'common.grey' }}
        />

        <Typography
          color="common.grey"
          p={1}
          lineHeight={1.75}
          fontWeight={500}
        >
          © {new Date().getFullYear()}
        </Typography>
      </Stack>

      <WelcomeModal open={open} setOpen={setOpen} />
    </>
  );
};

export default Footer;
